import _classCallCheck from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/createClass.js";

var FetchError = /*#__PURE__*/function () {
  function FetchError(error) {
    _classCallCheck(this, FetchError);

    this.error = error;
  }

  _createClass(FetchError, [{
    key: "status",
    get: function get() {
      return this.error.response ? this.error.response.status : 0;
    }
  }, {
    key: "message",
    get: function get() {
      return this.error.response ? this.error.response.data : 0;
    }
  }, {
    key: "getErrorDescriptions",
    value: function getErrorDescriptions() {
      var error = this.error;
      if (!navigator.onLine || !error.response) return navigator.onLine ? "پاسخی از سرور دریافت نشد" : "اتصال اینترنتی برقرار نیست";

      switch (error.response.status) {
        case 0:
          return "پاسخی از سرور دریافت نشد";

        case 400:
          return "درخواست شما معتبر نیست";

        case 401:
          return "توکن شما منقضی شده است";

        case 403:
          return "شما اجازه دسترسی به این قسمت را ندارید";

        case 404:
          return "خطای 404، چیزی یافت نشد";

        case 409:
          return "درخواست به دلیل تضاد با وضعیت فعلی منبع امکان پذیر نیست";

        case 500:
          return "بروز خطا در سمت سرور";
      }

      return "خطا در برقراری ارتباط با سرور";
    } // toastError(): void {
    //     toast(this.getErrorDescriptions());
    // }

  }]);

  return FetchError;
}();

export default FetchError;